export default {
  parameter: {
    label: '录屏参数字典',
    describe: '自定义常用的游戏录屏调整参数，提升录屏项目编辑效率。',
    table: {
      listEmpty: {
        describe:
          '您还没有录入录屏参数，录入常用参数，便于新建录屏项目时复用。',
        create: '立即开始制作吧！',
      },
      batch: {
        delete: '删除{num}条录屏参数',
        delete1: '删除该录屏参数',
        describe: '删除后不影响录屏项目。但参数删除后将无法恢复，确定删除吗？',
      },
      isRealized: '参数状态',
      notParameter: '未实现的参数不会在录屏编辑页面展示',
      implemented: '已实现',
      noImplemented: '未实现',
      isDelete: '未实现的参数被删除后将无法恢复，确定删除吗？',
      minValue: '最小值',
      maxValue: '最大值',
      name: '参数名称',
      operations: '操作',
      note: '说明',
      type: '参数类型',
      content: '选项值',
      defaults: '默认值',
      updatetime: '更新时间',
      operation: {
        edittips: '编辑',
        copytips: '复制',
        deletetips: '删除',
      },
    },
    edit: {
      plementedTips:
        '参数编辑后，需要开发在插件中刷新查看项目信息，否则可能会参数编辑失败。',
      notModifiable: '参数已实现，以下内容不可编辑',
      table: {
        type: '请选择参数类型',
        duplicateName: '参数名称不可与已有参数重名',
        maxInput: '最多输入{num}字符',
        correctValue: '请输入正确数值区间，默认值请在此区间内',
        sort: '排序',
        content: '内容',
        operation: '操作',
        add: '添加选项',
      },
      record: '编辑录屏参数',
      name: '参数名称',
      note: '说明',
      type: '参数类型',
      content: '选项值',
      preview: '预览效果',
      placeholder: {
        name: '请输入参数名称',
        description: '请输入说明',
        defaults: '请输入默认值',
      },
    },
    input: {
      tips: '请输入最{size}值',
      unlimitedTips: '不限',
      limitTips: '限制',
      small: '小',
      large: '大',
      minValue: '最小值',
      maxValue: '最大值',
    },
    new: '新建录屏参数',
    select: {
      single: '单选框',
      checkbox: '多选框',
      radio: '单选下拉',
      multi: '多选下拉',
      numvalue: '数值',
    },
    filter: {
      placeholder: '搜索参数名称',
    },
    create: {
      new: '新建录屏参数',
      name: '参数名称',
      note: '说明',
      type: '参数类型',
    },
  },
}
